type BrandMarkProps = {
  compact?: boolean;
  inverse?: boolean;
};

export function BrandMark({ compact = false, inverse = false }: BrandMarkProps) {
  return (
    <span
      className={[
        "brand-mark",
        compact ? "brand-mark--compact" : "",
        inverse ? "brand-mark--inverse" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      aria-label="National Treasury Office of the Accountant-General"
    >
      <span className="brand-mark__oag" aria-hidden="true">OAG</span>
      <span className="brand-mark__copy" aria-hidden="true">
        <small>National Treasury</small>
        <strong>Office of the</strong>
        <strong>Accountant-General</strong>
      </span>
    </span>
  );
}
